import { PermissionOptionsEnum } from './types';

const PermissionsWithConfigurableAccess: PermissionOptionsEnum[] = [
  PermissionOptionsEnum.CanInvokeModels,
  PermissionOptionsEnum.ExportMetrics,
];

export { PermissionsWithConfigurableAccess };
